'use client';

import { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';

const TRIGGER = 'zen';

// Keyboard sniffer with a rolling buffer matching the trigger word. When
// typed outside any text-input surface, fires a large concentric ring from
// viewport center. Multiple triggers stack. Disabled on /admin so it
// doesn't conflict with the ⌘K palette's keyboard handling.
export function ZenEasterEgg() {
  const pathname = usePathname();
  const [pulses, setPulses] = useState<number[]>([]);

  useEffect(() => {
    if (pathname?.startsWith('/admin')) return;
    let buf = '';
    function onKey(e: KeyboardEvent) {
      const t = e.target as HTMLElement | null;
      if (
        t &&
        (t.tagName === 'INPUT' ||
          t.tagName === 'TEXTAREA' ||
          (t instanceof HTMLElement && t.isContentEditable))
      ) {
        return;
      }
      if (e.key.length === 1) {
        buf = (buf + e.key.toLowerCase()).slice(-TRIGGER.length);
        if (buf === TRIGGER) {
          buf = '';
          const id = Date.now() + Math.random();
          setPulses((p) => [...p, id]);
          setTimeout(() => setPulses((p) => p.filter((x) => x !== id)), 2400);
        }
      }
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [pathname]);

  if (pulses.length === 0) return null;
  return (
    <div
      aria-hidden
      style={{
        position: 'fixed',
        inset: 0,
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 50,
      }}
    >
      {pulses.map((id) => (
        <span
          key={id}
          style={{
            position: 'absolute',
            width: 40,
            height: 40,
            borderRadius: '50%',
            border: '1.5px solid color-mix(in srgb, var(--accent) 70%, transparent)',
            animation: 'zen-pulse 2.4s cubic-bezier(0.16, 1, 0.3, 1) forwards',
          }}
        />
      ))}
    </div>
  );
}
